var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPxCloseLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "px-close-large") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.-Bosch-\\u2013-Damage-registration-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-109.000000, -108.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.008805,108.589434 L126.410566,109.991195 L119.401,117 L126.410566,124.008805 L125.008805,125.410566 L118,118.401 L110.991195,125.410566 L109.589434,124.008805 L116.598,117 L109.589434,109.991195 L110.991195,108.589434 L118,115.598 L125.008805,108.589434 Z",
    id: "px-close-large"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPxCloseLarge);
export default __webpack_public_path__ + "static/media/px-close-large.055f88fa2cbc09bdbb0657348aabfab6.svg";
export { ForwardRef as ReactComponent };